module.exports = __webpack_public_path__ + "img/logo-convites-abrapa.78890e13.jpg";